import ModalClass from "common/utils/ui/modal-class";
import "./digital-assets-dtf-modal-items/digital-assets-dtf-modal-items";
import "./digital-assets-dtf-modal.scss";

export class DigitalAssetsDtfModal extends ModalClass {
  #closeCallback;

  #sectionLogoSelector = ".js-digital-assets-dtf-modal-logo";

  #sectionsSelector = ".js-digital-assets-dtf-modal-section";

  constructor(props) {
    super(props);

    this.#closeCallback = props.closeCallback;
  }

  get #$modalSections() {
    return document.querySelectorAll(this.#sectionsSelector);
  }

  get #$modalLogo() {
    return document.querySelector(this.#sectionLogoSelector);
  }

  openModal(type) {
    super.openModal();

    const $activeSection = Array.from(this.#$modalSections).find(
      ({ dataset }) => dataset.section === type
    );

    this.#$modalSections.forEach($section => {
      $section.classList.toggle("hidden", $activeSection !== $section);
    });

    this.#$modalLogo.src = $activeSection.dataset.sectionLogo;
  }

  closeModalCallback() {
    super.closeModalCallback();

    if (this.#closeCallback instanceof Function) this.#closeCallback();
  }
}

export default props =>
  new DigitalAssetsDtfModal({
    modalSelector: "#digital-assets-dtf-modal",
    ...props
  });
